export default __webpack_public_path__ + "static/media/Fuji_Coaster.f1bfd51b.jpg";